import vue from "vue";

const state = {
  activeCards: {
    si_centre: []
  },
  activeCard: {
    si_centre: null
  },
  flyTo: {
    si_centre: {}
  }
};

const mutations = {
  SET_SMART_ACTIVE_CARD(state, { card, module }) {
    vue.set(state.activeCard, module, card);
  },
  ADD_SMART_ACTIVE_CARD(state, info) {
    const { layer_id, layer_name } = info;
    const { properties, layer } = info.item;

    if (!info.module || !properties || !layer) return;

    const found = state.activeCards[info.module].find(
      c => c.id === properties.id
    );
    properties.layer_item_id = `${layer_id}?id:${properties.id}`;
    properties.layer_id = layer_id;
    properties.layer_name = layer_name;
    const lastTab =
      state.activeCards[info.module][state.activeCards[info.module].length - 1];
    properties.tab_number = lastTab ? lastTab.tab_number + 1 : 1;

    if (!found) {
      state.activeCards[info.module].push(properties);
      state.activeCard[info.module] = properties.layer_item_id;
    } else {
      state.activeCard[info.module] = properties.layer_item_id;
    }
  },
  CHANGE_SMART_ACTIVE_CARD(state, info) {
    const { layer_id, layer_name } = info;
    const { properties, layer } = info.item;

    if (!info.module || !properties || !layer) return;

    const found = state.activeCards[info.module].find(
      c => c.id === properties.id
    );
    properties.layer_item_id = `${layer_id}?id:${properties.id}`;
    properties.layer_id = layer_id;
    properties.layer_name = layer_name;

    if (!found) {
      const index = state.activeCards[info.module].findIndex(
        e => e.layer_item_id === state.activeCard[info.module]
      );
      if (index > -1) {
        properties.tab_number =
          state.activeCards[info.module][index].tab_number;
        state.activeCards[info.module][index] = properties;
        state.activeCard[info.module] = properties.layer_item_id;
      }
    } else {
      state.activeCard[info.module] = properties.layer_item_id;
    }
  },
  REMOVE_SMART_ACTIVE_CARD(state, { id, module }) {
    state.activeCards[module].splice(
      state.activeCards[module].findIndex(c => c.layer_item_id === id),
      1
    );
    if (state.activeCards[module].length === 1)
      state.activeCards[module][0].tab_number = 1;
  },
  CLEAR_SMART_ACTIVE_CARDS(state, module) {
    state.activeCards[module] = [];
    state.activeCard[module] = null;
  },
  SET_FLY_TO_SMART_OBJECT(state, { module, item }) {
    vue.set(state.flyTo, module, item);
  },
  CLEAR_FLY_TO_SMART_OBJECT(state, module) {
    vue.set(state.flyTo, module, null);
  }
};

export default {
  state,
  mutations
};
